<template>
  <div v-for="(value, attribute) in properties.attributes" :key="attribute">
    <div v-if="value !== null" class="row">
      <div class="col-3" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
        {{ trans(`models.${resourceType}.attributes.${attribute}`) }}:
      </div>
      <div class="col-9">
        <presentation-field
          :meta="meta"
          :column="attribute"
          :column-type="getColumnType(attribute)"
          :mutation="meta.mutations[attribute] ?? null"
          :resource-type="resourceType"
          :value="getValue(attribute, 'attributes')"
        ></presentation-field>
      </div>
    </div>
  </div>
</template>

<script>
import PresentationField from '@kanrisha/components/Presentation/PresentationField';
export default {
  components: {
    PresentationField,
  },
  props: {
    properties: { type: Object, default: () => {} },
    relations: { type: Object, default: () => {} },
    resourceType: { type: String, default: () => '' },
    meta: { type: Object, default: () => {} },
  },
  setup(props) {
    const getValue = (column, category) => {
      if (getColumnType(column) === 'relation' && props.relations) {
        let relation = column.substring(0, column.length - 3);
        return props.relations[category] ? props.relations[category][relation] : null;
      }

      return props.properties[category] ? props.properties[category][column] : null;
    };

    const getColumnType = (column) => {
      return props.meta.elementTypes[column.substring(0, column.length - 3)] ?? props.meta.elementTypes[column] ?? null;
    };

    return {
      getColumnType,
      getValue,
    };
  },
};
</script>
